import { useEffect, useState } from 'react';

const useEnv = () => {
    const [envData, setEnvData] = useState(process.env);

    useEffect(() => {
        setEnvData(process.env);
    }, []);

    return envData;
};

export default useEnv;
